import { getBrTcv } from 'helpers/brCalculationHelper';

export const getBrLocationReviewColumnDefs = [
    {
        headerName: 'Name',
        field: 'locationName',
        minWidth: 180,
        cellRenderer: 'agGroupCellRenderer',
    },
    {
        headerName: 'Location',
        field: 'location',
        valueGetter: ({ data }: any) => {
            if (!!data.address1 && !!data.city && !!data.state && !!data.zip) {
                return `${data.address1}, ${data.city}, ${data.state} ${data.zip}`;
            } else if (!!data.locationLat && !!data.locationLon) {
                return `Lat Lon: ${data.locationLat} ${data.locationLon}`;
            } else {
                return `No Address Provided`;
            }
        },
        minWidth: 180,
        flex: 2,
    },
    {
        headerName: 'TCV',
        field: 'tcv',
        minWidth: 140,
        valueGetter: ({ data }: any) =>
            getBrTcv(data.hardCosts, data.softCosts, data.lossOfGrossEarnings, data.lossOfRentalIncome),
        valueFormatter: ({ value }: { value: number }) => (value != null ? `$${value.toLocaleString()}` : ''),
    },
    {
        headerName: 'Program Premium',
        field: 'premium',
        minWidth: 140,
        valueFormatter: ({ value }: { value: number | string }) => {
            if (value == null) return '';

            if (typeof value === 'string' && value.includes('*')) {
                const numericValue = parseFloat(value.replace('*', '').trim());
                return isNaN(numericValue) ? '' : `$${numericValue.toLocaleString()} *`;
            } else if (typeof value === 'string') {
                return value;
            } else {
                return `$${value.toLocaleString()}`;
            }
        },
    },
];

export const defaultColDef = {
    flex: 1,
};
